{
  "rampInfoCard": {
    "labels": {
      "aircraft": "Aéronef",
      "utilization": "Utilisation",
      "wind": "Vent",
      "trips": "Vols",
      "grossDimensions": "Dimensions hors tout",
      "parkableArea": "Aire de stationnement"
    },
    "tooltips": {
      "aircraftOnRamp": "Aéronef stationné dans le périmètre du tarmac / Tous les aéronefs affichés à l'écran.",
      "parkableArea": "Zones de tarmac délimitées, à l'exclusion des zones non stationnables (ex. : voies de circulation, obstacles).",
      "utilization": "Aéronefs stationnés dans le périmètre du tarmac / Tous les aéronefs affichés à l'écran. (Un aéronef est considéré comme stationné lorsque ses roues principales se trouvent dans le périmètre global du tarmac)",
      "grossDimensions": "Longueur et largeur de base du contour du tarmac",
      "trips": "Vols actifs / Vols à venir assignés à ce tarmac",
      "wind": {
        "loading": "Conditions de vent actuelles depuis la station météo à proximité (mise à jour toutes les 5 minutes)",
        "error": "Données de vent non disponibles depuis {{stationInfo}}\nDernière vérification : {{lastUpdated}}\nActualisation toutes les 5 minutes",
        "current": "Conditions de vent actuelles de {{stationInfo}}\nDernière mise à jour : {{lastUpdated}}\nActualisation toutes les 5 minutes"
      }
    }
  },
  "namePrefixes": {
    "allTenants": "[Tous locataires]",
    "allTieDownTenants": "[Tous les locataires d'amarrage]"
  },
  "aircraftFinder": {
    "tooltip": "Rechercher aéronef",
    "searchPlaceholder": "Rechercher immat., modèle, opérateur",
    "clear": "Effacer"
  },
  "autoPark": {
    "dialog": {
      "title": "Configuration AutoPark",
      "tabs": {
        "timeRange": "Période",
        "algorithm": "Algorithme"
      },
      "timeRange": {
        "startTime": "Heure de début",
        "endTime": "Heure de fin",
        "duration": "Durée",
        "presets": {
          "oneDay": "1 jour",
          "threeDays": "3 jours",
          "sevenDays": "7 jours"
        },
        "tripSelection": "Vols dans la période sélectionnée : {{selected}} sur {{total}} sélectionnés"
      },
      "buttons": {
        "cancel": "Annuler",
        "run": "Lancer AutoPark"
      }
    },
    "button": {
      "label": "AutoPark",
      "disabledMessage": "AutoParking n'est pas activé pour ce tarmac. Activez-le dans les paramètres du tarmac.",
      "tooltip": "AutoPark"
    },
    "decisionLog": {
      "tabs": {
        "spotOccupancy": "Occupation des postes",
        "listView": "Vue liste",
        "timelineDev": "Chronologie (Dev)",
        "decisionLog": "Journal des décisions ({{count}} aéronefs)"
      },
      "statistics": {
        "aircraftPlaced": "Appareil placé",
        "successRate": "Taux de réussite",
        "unplacedAircraft": "Aéronefs non placés",
        "partiallyPlaced": "Partiellement placé",
        "partialPlacementNote": "Placé pour une partie du vol",
        "averageMoves": "Mouvements moyens",
        "executionTime": "Temps d'exécution"
      },
      "filters": {
        "all": "Tous ({{count}})",
        "placed": "Placé ({{count}})",
        "unplaced": "Non placés ({{count}})"
      },
      "buttons": {
        "close": "Fermer",
        "apply": "Appliquer au tarmac",
        "applying": "Chargement..."
      },
      "progress": {
        "title": "Application des résultats en cours",
        "message": "Enregistrement des placements d'aéronefs dans la base de données. Veuillez patienter...",
        "itemName": "placement"
      }
    },
    "placementTable": {
      "headers": {
        "status": "Statut",
        "tailNumber": "N° immat.",
        "spots": "Place(s)",
        "arrival": "Arrivée",
        "departure": "Départ",
        "dwell": "Escale"
      },
      "summary": {
        "showing": "Affichage de {{filtered}} sur {{total}}",
        "placed": "{{count}} placé",
        "unplaced": "{{count}} non placé(s)"
      },
      "filters": {
        "all": "Tous",
        "placed": "Placé",
        "unplaced": "Non placé",
        "searchPlaceholder": "Rechercher immatriculations..."
      }
    },
    "tripList": {
      "title": "Vols ({{selected}}/{{total}} sélectionnés)",
      "locked": "{{count}} verrouillé",
      "buttons": {
        "all": "Tous",
        "none": "Aucun",
        "lockAll": "Verrouiller",
        "unlockAll": "Tout débloquer",
        "includeAll": "Tout",
        "excludeAll": "Aucun"
      },
      "tooltips": {
        "lockAll": "Verrouiller les vols (garder positions)",
        "unlockAll": "Débloquer vols (autoriser replacement)",
        "includeAll": "Inclure tous les vols",
        "excludeAll": "Exclure tous les vols",
        "lock": "Verrouiller (fixer)",
        "unlock": "Déverrouiller (repark)",
        "clickToLock": "Cliquer pour verrouiller",
        "clickToExclude": "Cliquer pour exclure",
        "clickToInclude": "Cliquer pour inclure",
        "keyboardHint": "↑↓ Naviguer • Espace Sélectionner • L Verrouiller • Maj+L Tout verrouiller"
      },
      "filter": {
        "placeholder": "Filtrer par immat., marque, modèle..."
      },
      "emptyState": {
        "title": "Aucun vol dans la période sélectionnée",
        "hint": "Essayez d'élargir la plage de dates avec les boutons 3j ou 7j ci-dessus, ou vérifiez que ce tarmac a des vols programmés.",
        "addTrips": "Les vols peuvent être ajoutés depuis la vue Calendrier."
      },
      "current": "Actuel :",
      "invalidDates": "Dates invalides",
      "unknownAircraft": "Aéronef inconnu",
      "sizeCategories": {
        "small": {
          "label": "S",
          "tooltip": "Petit (<15m d'envergure)"
        },
        "medium": {
          "label": "M",
          "tooltip": "Moyen (envergure 15-25 m)"
        },
        "large": {
          "label": "L",
          "tooltip": "Grand (envergure 24-37 m)"
        },
        "extraLarge": {
          "label": "XL",
          "tooltip": "Très grand (>120ft d'envergure)"
        }
      },
      "noTrips": "Aucun vol dans la période sélectionnée",
      "assign": "Attribuer",
      "selectLocation": "Sélectionner l'emplacement",
      "hangarsSection": "Hangars",
      "rampsSection": "Autres tarmacs"
    },
    "assignSuccess": "{{tailNumber}} attribué à {{locationName}}",
    "assignError": "Échec de l'attribution de l'aéronef",
    "capacityBar": {
      "title": "Capacité de places",
      "utilization": "{{placed}}/{{total}} places ({{percent}} % utilisées)",
      "legend": {
        "placed": "Placé ({{count}})",
        "available": "Disponibles ({{count}})",
        "filtered": "Filtré ({{count}})",
        "breakdown": {
          "time": "Heure ({{count}})",
          "size": "Taille ({{count}})",
          "duration": "Durée ({{count}})",
          "disabled": "Désactivés ({{count}})",
          "geometry": "Géométrie ({{count}})"
        }
      }
    },
    "parkNextButton": {
      "label": "Parc suivant",
      "tooltip": "Parc suivant",
      "disabledMessage": "Aucun aéronef non placé disponible."
    },
    "decisionLogButton": {
      "tooltip": "Historique des décisions",
      "disabledTooltip": "Exécutez d'abord AutoPark pour générer le journal de décisions"
    },
    "unplacedAircraftDialog": {
      "title": "Aéronefs non placés à {{time}}",
      "subtitle": "{{count}} aéronefs n'ont pas pu être placés pour le moment",
      "noAircraft": "Aucun aéronef non placé pour le moment",
      "closeLabel": "Fermer"
    },
    "timeRangePicker": {
      "durationFormat": {
        "daysHoursMinutes": "{{days}}j {{hours}}h {{minutes}}m",
        "hoursMinutes": "{{hours}}h {{minutes}}m",
        "minutes": "{{minutes}} min"
      }
    },
    "scheduleGanttDialog": {
      "title": "Planning {{rampName}}",
      "statistics": {
        "aircraftPlaced": "Appareil placé",
        "avgUtilization": "Utilisation moy."
      },
      "buttons": {
        "print": "Impr.",
        "close": "Fermer",
        "applyToDatabase": "Appliquer à la BDD",
        "applying": "Chargement..."
      },
      "messages": {
        "unsavedChanges": "Vous avez des modifications non enregistrées. Voulez-vous vraiment fermer ?",
        "pendingChanges": "{{count}} modif. non enregistrée"
      },
      "labels": {
        "close": "Fermer"
      }
    },
    "editableSpotCell": {
      "otherSpots": "Autres lieux"
    },
    "placementTableRowExpanded": {
      "segmentBreakdown": "Détail du segment ({{segmentCount}} segment, {{moveCount}} mouvement)",
      "partialPlacement": "Placement partiel - {{count}} écart",
      "placed": "Placé :",
      "gap": "Écart:",
      "gapLabel": "Écart {{index}} :",
      "noAvailableSpots": "Aucun créneau disponible",
      "checkDecisionLog": "Consultez l'onglet Journal des décisions pour le détail des filtres"
    },
    "spotSchedulePrintView": {
      "unknownType": "Type inconnu",
      "segmentNotes": "Segment {{current}}/{{total}} ({{moves}} déplacements)",
      "title": "Résultats AutoPark - {{rampName}} - {{dateRange}}",
      "statistics": {
        "aircraftPlaced": "Appareil placé",
        "successRate": "Taux de réussite",
        "averageMoves": "Mouvements moyens"
      },
      "tableHeaders": {
        "tailNumber": "Immatriculation",
        "aircraftType": "Type d'aéronef",
        "arrival": "Arrivée",
        "departure": "Départ",
        "duration": "Durée",
        "notes": "Notes"
      },
      "noAircraftScheduled": "(Aucun aéronef prévu)",
      "unplacedAircraft": "Aéronefs non placés ({{count}})"
    },
    "placementList": {
      "title": "Affectations de stationnement",
      "sections": {
        "placed": "Placé",
        "unplaced": "Non placé"
      },
      "headers": {
        "tail": "Queue",
        "spot": "Place",
        "zone": "Zone",
        "time": "Heure"
      },
      "labels": {
        "allows": "permet",
        "coverage": "couverture",
        "requested": "req",
        "spotLock": "{{count}} verrou place",
        "move": "{{count}} déplacement",
        "moveAt": "à {{time}}"
      },
      "tooltips": {
        "sizeVerySmall": "Très petit (ex. : Cessna 172)",
        "sizeSmall": "Petit (ex. : Citation, Phenom 300)",
        "sizeMidsize": "Moyen (ex. : Challenger 604)",
        "sizeSuperMidsize": "Super-Midsize (ex. Gulfstream G650)",
        "sizeLarge": "Grand (ex. : Global 7500, BBJ)",
        "sizeEnormous": "Très grande taille (ex. : avions de ligne)",
        "blocksOne": "Bloque {{tailNumber}} (départ {{departureTime}})",
        "blocksMultiple": "Bloque {{count}} aéronef(s) : {{tailNumbers}}"
      }
    },
    "timelineView": {
      "title": "Chronologie d'occupation des spots (fenêtre de {{horizonHours}}h)",
      "headers": {
        "zone": "Zone",
        "spot": "Place",
        "day": "Jour {{dayNumber}}"
      },
      "rows": {
        "utilization": "Utilisation",
        "placed": "Placé",
        "unplaced": "Non placé"
      },
      "labels": {
        "disabled": "(DÉSACTIVÉ)",
        "stagingArrival": " (A)",
        "stagingDeparture": " (D)"
      },
      "tooltips": {
        "spotDisabled": "Spot désactivé (non disponible pour l'algorithme)",
        "zoneDisabled": "{{zoneName}} désactivé (tous les emplacements de la zone indisponibles)",
        "spotAndZoneDisabled": "Zone désactivée ET {{zoneName}} désactivé",
        "departing": "Départ : {{tailNumbers}}",
        "unplacedAircraft": "{{tailNumbers}} (cliquez pour plus de détails)",
        "blocked": "Bloqué par {{tailNumber}} à {{spotId}} (départ {{departureTime}})"
      }
    },
    "parkingConfigForm": {
      "time": {
        "min": "min",
        "hour": "heure",
        "hours": "heures",
        "disabled": "0 min (désactivé)"
      },
      "buffer": {
        "title": "Tampon",
        "helpText": "Temps supplémentaire (minutes) ajouté avant l'arrivée et après le départ pour éviter les conflits d'espacement. Exemple : un appareil décolle à 10h00. Avec un buffer de 15 min, le spot devient disponible à 10h15.",
        "options": {
          "none": "Aucune marge (0)",
          "minutes10": "10 minutes",
          "standard": "Standard (15)",
          "high": "Élevé (20)"
        }
      },
      "plannedMoves": {
        "title": "Mouvements prévus",
        "helpText": "Nombre maximum de déplacements autorisés pour un aéronef pendant son stationnement. 0 = aucun déplacement (l'aéronef reste au même emplacement). Exemple : Avec 1 déplacement autorisé, l'aéronef peut stationner au Spot A (8:00-12:00) puis être déplacé au Spot B (12:00-16:00).",
        "options": {
          "none": "Sans répart. (0)",
          "allow1": "1 déplacement",
          "allow2": "2 déplacements max",
          "allow3": "3 déplacements max"
        }
      },
      "allowTrapping": {
        "title": "Autoriser le piégeage",
        "helpText": "Lorsque activée, permet de placer des aéronefs sur des emplacements bloquant d'autres départs. Sinon, place uniquement sur des emplacements libres (certains aéronefs peuvent rester non placés).",
        "label": "Autoriser le piégeage"
      },
      "egressWeight": {
        "title": "Masse au départ",
        "helpText": "Contrôle l'intensité avec laquelle l'algorithme évite les placements qui bloquent d'autres aéronefs. Faible (1x) : pénalité minimale. Moyen (2x) : pénalité modérée. Élevé (5x) : pénalité forte.",
        "options": {
          "low": "Faible (1x)",
          "medium": "Moyen (2x)",
          "high": "Élevé (5x)"
        }
      },
      "wasteWeight": {
        "title": "Poids des déchets",
        "helpText": "Contrôle l'intensité avec laquelle l'algorithme évite de placer les petits aéronefs sur des emplacements surdimensionnés. Permet de réserver les grands emplacements premium aux gros aéronefs qui en ont réellement besoin.",
        "options": {
          "disabled": "Désactivé (0x)",
          "low": "Faible (0,5x)",
          "medium": "Moyen (1x)",
          "high": "Élevé (2x)",
          "veryHigh": "Très élevé (3x)"
        }
      },
      "structuralWeight": {
        "title": "Masse structurale",
        "helpText": "Contrôle la pénalité pour les spots avec une topologie de blocage complexe. Encourage l'utilisation des spots « propres » en priorité, réservant les spots complexes en dernier recours. Faible (0.05x) : minimal. Standard (0.1x) : départage. Élevé (0.5x) : forte préférence.",
        "options": {
          "disabled": "Désactivé (0x)",
          "low": "Faible (0.05x)",
          "standard": "Standard (0,1x)",
          "medium": "Moyen (0.2x)",
          "high": "Élevé (0,5x)"
        }
      },
      "zonePriorityWeight": {
        "title": "Priorité de zone",
        "helpText": "Contrôle la préférence pour les zones prioritaires. Désactivé (0x) : ignorer les zones. Faible (0.5x) : préférence légère. Standard (1x) : équilibré. Élevé (2x) : préférence forte. Très élevé (3x) : préférence maximale.",
        "options": {
          "disabled": "Désactivé (0x)",
          "low": "Faible (0,5x)",
          "standard": "Standard (1x)",
          "high": "Élevé (2x)",
          "veryHigh": "Très élevé (3x)"
        }
      },
      "minDwellWeight": {
        "title": "Poids min. d'escale",
        "helpText": "Contrôle la préférence pour les postes avec durée de stationnement minimale. Attire les aéronefs long séjour vers les postes éloignés/débordement et repousse les aéronefs court séjour. Désactivé (0x) : ignorer la durée minimale. Faible (0.5x) : préférence légère. Standard (1x) : équilibré. Élevé (2x) : préférence forte. Très élevé (3x) : préférence maximale.",
        "options": {
          "disabled": "Désactivé (0x)",
          "low": "Faible (0,5x)",
          "standard": "Standard (1x)",
          "high": "Élevé (2x)",
          "veryHigh": "Très élevé (3x)"
        }
      },
      "arrivalStagingTime": {
        "title": "Heure de staging arrivée",
        "helpText": "Durée des opérations de service à l'arrivée : déchargement, douane, avitaillement, nettoyage. Définir à 0 pour désactiver le staging à l'arrivée. Nécessite des zones de staging configurées sur le tarmac. Plage valide : 0-{{max}} minutes."
      },
      "departureStagingTime": {
        "title": "Heure de mise en place au départ",
        "helpText": "Durée de préparation au départ : embarquement, vérifications finales, documents. Définir à 0 pour désactiver la zone de préparation au départ. Nécessite des zones de préparation configurées sur le tarmac. Plage valide : 0-{{max}} minutes."
      },
      "quickTurnThreshold": {
        "title": "Seuil de Quick Turn",
        "helpText": "Durée de stationnement minimale pour utiliser le flux de staging. Les appareils avec des escales plus courtes contournent le staging et vont directement aux emplacements permanents. Plage valide : {{min}}-{{max}} minutes.",
        "options": {
          "hour1": "1 heure",
          "hours1_5": "1,5 heure",
          "standard": "Standard (2 heures)",
          "hours3": "3 heures",
          "hours4": "4 heures"
        }
      },
      "sortingStrategy": {
        "title": "Stratégie de tri",
        "helpText": "Contrôle l'ordre de traitement des aircraft. Par contrainte de taille : place en priorité les aircraft ayant moins d'options de spot. Par arrivée : traite par heure d'arrivée. Hybride : combine contrainte de taille + durée de stationnement la plus longue.",
        "options": {
          "arrival": "Ordre d'arrivée",
          "sizeConstrained": "Taille contrainte en premier",
          "longestDwell": "Attente la plus longue",
          "latestDeparture": "Départ le plus récent en premier",
          "hybrid": "Hybride (Taille + Durée)",
          "largestFirst": "Plus grand d'abord"
        }
      }
    },
    "editableTimeCell": {
      "placeholder": "HH:mm"
    },
    "index": {
      "disabledMessages": {
        "autoParkingNotEnabledWithSettings": "AutoParking n'est pas activé pour ce tarmac. Activez-le dans les paramètres du tarmac.",
        "autoParkingNotEnabled": "AutoParking n'est pas activé pour ce tarmac.",
        "noUnplacedAircraft": "Aucun aéronef non placé disponible."
      },
      "buttons": {
        "checkFit": "Vérifier"
      }
    },
    "spotOccupancyGantt": {
      "sizeCategories": {
        "verySmall": "Très petit",
        "small": "Petit",
        "midsize": "Midsize",
        "superMidsize": "Super-Midsize",
        "large": "Grand",
        "enormous": "Énorme"
      },
      "errors": {
        "spotNotFound": "Spot introuvable"
      },
      "unknownType": "Type inconnu",
      "staging": {
        "arrival": "Gestion des arrivées",
        "departure": "Départ - Préparation"
      },
      "moveCount": "{{count}} déplacement",
      "currentlyViewing": "Affichage actuel :"
    },
    "legend": {
      "title": "Légende des couleurs",
      "auto": "Auto-assigné",
      "manual": "Manuel",
      "staging": "Zone de transit",
      "locked": "Verrouillé"
    },
    "planningDialog": {
      "title": "Planification AutoPark",
      "stats": {
        "placed": "{{placed}}/{{total}} placé(s)",
        "rate": "Taux de {{percent}} %"
      },
      "buttons": {
        "preview": "Aperçu",
        "running": "Chargement...",
        "print": "Impr.",
        "settings": "Paramètres",
        "applyToRamp": "Appliquer au tarmac",
        "applying": "Chargement...",
        "cancel": "Annuler"
      },
      "tooltips": {
        "noTripsInRange": "Aucun vol sur cette période",
        "unlockToPreview": "Débloquer pour prévisualiser",
        "showTripList": "Afficher les vols",
        "hideTripList": "Masquer les vols",
        "configureAlgorithm": "Configurez le placement des aéronefs par AutoPark. Les préréglages offrent des configurations rapides, ou ajustez les pondérations individuelles ci-dessous."
      },
      "presets": {
        "label": "Préréglé",
        "balanced": {
          "label": "Équilibré (par défaut)",
          "description": "Bon équilibre entre efficacité et stabilité"
        },
        "conservative": {
          "label": "Conservateur",
          "description": "Minimiser les déplacements, privilégier la stabilité"
        },
        "aggressive": {
          "label": "Agressif",
          "description": "Optimiser l'espace"
        },
        "custom": {
          "label": "Perso.",
          "description": "Configuration manuelle"
        }
      },
      "workflow": {
        "title": "Comment fonctionne AutoPark",
        "step1": "<strong>Sélectionnez des vols</strong> dans le panneau gauche pour les inclure",
        "step2": "<strong>Verrouillez les vols</strong> que vous souhaitez conserver à leur emplacement actuel",
        "step3": "<strong>Cliquez sur « Lancer l'aperçu »</strong> pour voir les suggestions de l'algorithme",
        "step4": "<strong>Vérifiez les modifications</strong>, puis Appliquer au tarmac",
        "footer": "Vols verrouillés : fixes. Vols déverrouillés : nouveaux emplacements possibles selon taille, arrivée et priorité de zone."
      },
      "algorithmSettings": "Paramètres de l'algorithme"
    },
    "impactSummary": {
      "locked": "verrouillé",
      "moving": "en cours",
      "new": "neuf",
      "conflicts": "conflits",
      "tooltips": {
        "locked": "{{count}} vols resteront à leur position actuelle",
        "moving": "{{count}} vols seront déplacés vers de nouveaux emplacements",
        "new": "{{count}} vols non assignés recevront des créneaux",
        "conflicts": "{{count}} vols n'ont pas pu être placés",
        "utilization": "Évolution du taux d'occupation : {{before}} % → {{after}} %"
      },
      "details": {
        "moves": "Mouvements ({{count}}) :",
        "conflicts": "Conflits ({{count}}) :"
      },
      "unknown": "Inconnu"
    }
  },
  "ramp": {
    "referenceModeAlert": "Ceci est votre tarmac de référence des locataires d'attaches. Il affiche uniquement vos locataires d'attaches et est distinct de votre tarmac actuel actif."
  },
  "rampPrintLayout": {
    "aircraft": "Aéronef",
    "footer": {
      "automaticallyOptimizedBy": "Optimisé automatiquement par",
      "contactInfo": "Contactez-nous sur www.airplx.com ou à peter@airplx.com."
    }
  },
  "temporalTest": {
    "index": {
      "title": "Test de stationnement temporel",
      "testScenario": "Scénario de test",
      "buttons": {
        "running": "Chargement...",
        "runPlanner": "Planificateur"
      },
      "stats": {
        "planningStatistics": "Stats de planification",
        "totalAircraft": "Total aéronefs :",
        "placed": "Placé :",
        "unplaced": "Non placé :",
        "plannedMoves": "Mouvements prévus :",
        "traps": "Blocages :",
        "aircraftBlocking": "aéronefs bloquant",
        "others": "autres",
        "none": "Aucun ✓",
        "expected": "Attendu :",
        "placedSlash": "placés /",
        "unplacedSuffix": "non placés",
        "matchCheck": " ✓",
        "mismatch": " (écart)"
      },
      "instructions": "Sélectionnez un scénario et cliquez sur « Lancer le planificateur » pour générer les affectations de stationnement",
      "decisionLog": "Journal des décisions ({{count}} événements)",
      "parameterGuide": {
        "title": "Guide des paramètres",
        "buffer": {
          "title": "Marge",
          "description": "Temps supplémentaire (minutes) ajouté avant l'arrivée et après le départ pour éviter les conflits d'espacement serré.",
          "example": "Exemple : L'aéronef A part à 10h00. Avec une marge de 15min, la place devient disponible à 10h15, évitant les rotations précipitées."
        },
        "plannedMoves": {
          "title": "Déplacements planifiés",
          "description": "Nombre maximum de fois qu'un aéronef peut être déplacé pendant son séjour. 0 = pas de déplacements (l'aéronef reste sur une seule place).",
          "example": "Exemple : Un aéronef arrive à 8h, part à 16h. Avec 1 déplacement autorisé, il pourrait stationner à la place A (8h-12h) puis se déplacer vers la place B (12h-16h) si aucune place unique n'est disponible pour les 8 heures complètes."
        },
        "allowTrapping": {
          "title": "Autoriser le blocage",
          "description": "Lorsque coché, permet de placer des aéronefs sur des places qui bloquent le chemin de sortie d'autres aéronefs. Lorsque décoché, ne place les aéronefs que sur des places qui ne bloquent pas les autres (peut laisser des aéronefs non placés).",
          "example": "Exemple : La rangée a les places A (avant) et B (arrière). L'aéronef à B part à 14h, l'aéronef à A part à 16h. Avec blocage interdit, B ne peut pas être utilisé (serait bloqué). Avec blocage autorisé, les deux places peuvent être utilisées."
        },
        "egressWeight": {
          "title": "Poids de sortie",
          "description": "Contrôle la force avec laquelle l'algorithme évite les placements qui bloquent d'autres aéronefs.",
          "levels": {
            "low": "• Faible (1x) : Pénalité minimale - préfère les places sans blocage mais accepte le blocage si nécessaire",
            "medium": "• Moyen (2x) : Pénalité modérée - travaille plus dur pour éviter les blocages, peut laisser des aéronefs non placés",
            "high": "• Élevé (5x) : Forte pénalité - priorise fortement les placements sans blocage sur le nombre de placements"
          },
          "example": "Exemple : Place A bloque 2 aéronefs (score = 2 × poids), Place B bloque 0 (score = 0). Avec poids Élevé (5x), Place A a un score de 10 vs Place B score de 0, rendant Place B fortement préférée."
        },
        "wasteWeight": {
          "title": "Poids de gaspillage",
          "description": "Contrôle la force avec laquelle l'algorithme évite de placer de petits aéronefs sur des places surdimensionnées. Aide à réserver les grandes places premium aux grands aéronefs qui en ont vraiment besoin.",
          "levels": {
            "disabled": "• Désactivé (0x) : Pas de pénalité - ignore l'inadéquation de taille, l'algorithme place librement",
            "low": "• Faible (0.5x) : Légère incitation - légère préférence pour les places de bonne taille",
            "medium": "• Moyen (1x) : Pénalité équilibrée - comparable au poids de sortie",
            "high": "• Élevé (2x) : Forte préférence - travaille dur pour éviter les places surdimensionnées",
            "veryHigh": "• Très élevé (3x) : Pénalité extrême - réserve agressivement les grandes places aux grands aéronefs"
          },
          "example": "Exemple : Citation (petit) considérant une place grande a gaspillage=3. Avec poids Moyen (1x), pénalité de gaspillage=3. Avec poids Élevé (2x), pénalité=6. Si une place petite-seulement a un score=0 et la grande place a une pénalité de sortie=2, alors : Moyen fait des scores 0 vs 5 (préfère petit), Élevé fait des scores 0 vs 8 (préfère fortement petit)."
        },
        "sortingStrategy": {
          "title": "Stratégie de tri",
          "description": "Contrôle l'ordre dans lequel les aéronefs sont traités par l'algorithme de placement glouton. Différents ordres peuvent affecter considérablement les taux de placement.",
          "strategies": {
            "arrivalOrder": "• Ordre d'arrivée : Traite par heure d'arrivée (plus tôt d'abord). Réaliste mais peut gaspiller les places flexibles.",
            "sizeConstrained": "• Contraint par taille d'abord : Place d'abord les aéronefs avec moins de places compatibles. Évite de gaspiller les places flexibles sur des aéronefs flexibles.",
            "longestDwell": "• Plus long séjour d'abord : Place d'abord les aéronefs qui restent le plus longtemps. Assure que les longs séjours ont la priorité.",
            "latestDeparture": "• Départ le plus tardif en premier : Placer les aéronefs au départ le plus tardif en premier. Optimise le stationnement de nuit.",
            "hybrid": "• Hybride : Combine les contraintes de taille et le temps d'attente le plus long (plus contraint + plus ancien en premier)."
          },
          "example": "Exemple : 2 places (A=Petits uniquement, B=Flexible). Un petit aéronef arrive en premier, l'algorithme glouton le place en B (gaspille la flexibilité). Un gros aéronef arrive, refusé (seule B convient, maintenant occupée). Avec l'ordonnancement par contrainte de taille : le gros est placé en B d'abord, le petit prend A → les deux sont placés !"
        },
        "sizeCategories": {
          "title": "Catégories de taille",
          "description": "Les aéronefs sont classés par catégorie de taille selon leur envergure. Les emplacements disposent de règles qui définissent les tailles d'aéronefs acceptées, permettant une gestion flexible du stationnement.",
          "sizes": {
            "verySmall": "• VS (Very Small) : envergure ~35-40ft (Cessna 172, Piper PA-28, Cirrus SR22)",
            "small": "• S (Small) : envergure ~50-60ft (Citations, Phenom 300, King Air 350, Learjet 45)",
            "midsize": "• M (Midsize) : ~60-70ft d'envergure (Challenger 604/605, Falcon 900, Gulfstream G280)",
            "superMidsize": "• SM (Super-Midsize) : ~75-100ft d'envergure (Falcon 7X, Gulfstream G500/G650)",
            "large": "• L (Grand) : envergure ~30-37 m (Global 6000/7500, Gulfstream G700, BBJ)"
          },
          "spotPolicies": "Politiques d'emplacement : Chaque emplacement dispose d'une liste de tailles autorisées qui détermine quels aéronefs peuvent s'y stationner.",
          "policies": {
            "universal": "Universel : [VS, S, M, SM, L] - accepte toutes les tailles d'aéronefs",
            "largeOnly": "• Grande taille uniquement : [L] - réserve l'emplacement aux grands aéronefs (évite le gaspillage)",
            "commonJets": "• Jets courants : [S, M] - bloque les avions très petits et grands"
          },
          "example": "Exemple : le spot A01 accepte [S, M] (petits et moyens appareils uniquement). Un gros appareil (L) arrive mais ne peut pas utiliser A01 en raison des restrictions de taille. Il doit trouver un spot acceptant les gros appareils."
        }
      }
    },
    "decisionLogDisplay": {
      "noEntries": "Aucune entrée de décision",
      "lane": "Voie",
      "timeConflict": "❌ Conflit horaire",
      "blocks": "📍 Blocs",
      "deps": "✓ Dép :",
      "aircraftSize": "Taille de l'aéronef",
      "breakdown": "Répartition",
      "collision": "Collision",
      "depsWarning": "Avertissement Deps",
      "durationAnalysis": {
        "exceedsBy": "Dépasse de",
        "minutes": "Minutes",
        "requiredDwell": "Escale requise",
        "spotLimit": "Limite places",
        "title": "Analyse de durée"
      },
      "of": "De",
      "otherOptions": "Autres options",
      "primary": "Principal",
      "primaryBlocker": "Bloqueur principal",
      "quickFix": "Corriger vite",
      "rejectionReasons": {
        "durationExceeded": "Durée dépassée",
        "geometryCollision": "Collision géométrique",
        "sizeIncompatible": "Taille incompatible",
        "spotsDisabled": "Places désactivées",
        "timeConflicts": "Conflits horaires",
        "unknown": "Inconnu"
      },
      "sizeAnalysis": {
        "aircraft": "Aéronef",
        "length": "Longueur",
        "none": "Aucun",
        "spotsAllowing": "Places autorisées",
        "spotsBySize": "Places par taille",
        "title": "Analyse des tailles",
        "wingspan": "Envergure"
      },
      "spots": "Places",
      "timeAnalysis": {
        "aircraftDwell": "Temps d'escale",
        "conflictWindow": "Fenêtre de conflit",
        "minutes": "Minutes",
        "minutesSuffix": "Suffixe des minutes",
        "peakCongestion": "Pic de congestion",
        "spotsOccupied": "Places occupées",
        "spotsOccupiedSuffix": "Suffixe des places occupées",
        "timeConflicts": "Conflits horaires",
        "title": "Analyse du temps"
      }
    }
  },
  "lastMinuteInsertion": {
    "dialog": {
      "aircraftStatus": {
        "spotUnknown": "Lieu inconnu",
        "unknown": "Inconnu",
        "unplaced": "Non placé"
      },
      "buttons": {
        "checkAvailability": "Vérifier la disponibilité",
        "close": "Fermer"
      },
      "errors": {
        "invalidTimeRange": "Erreur : Plage horaire invalide"
      },
      "labels": {
        "aircraft": "Aéronef",
        "arrivalTime": "Heure d'arrivée",
        "departureTime": "Heure de départ",
        "maxAircraftMoves": "Mouvements d'aéronefs max."
      },
      "placeholders": {
        "selectAircraft": "Sélectionner l'aéronef"
      },
      "results": {
        "failed": {
          "suggestions": "Suggestions",
          "title": "Échec"
        },
        "localRepair": {
          "message": "Réparation locale",
          "title": "Réparation locale"
        },
        "zeroDisruption": {
          "message": "Zéro perturbation",
          "title": "Zéro perturbation"
        }
      },
      "slider": {
        "marks": {
          "max": "Max",
          "two": "Deux",
          "zero": "Zéro"
        }
      },
      "title": "Dialogue"
    }
  }
}
